import AudioService from "../../services/AudioService";

const BGM_AUTO_PLAY_KEY = "puzzle.bgmAutoPlay";

/** Fired when the user mutes or unmutes BGM so layout + play pages stay in sync. */
export const BGM_AUTO_PLAY_EVENT = "puzzle:bgm-auto-play";

/** @returns {boolean | null} — `null` when this browser has no saved choice yet. */
export function readBgmAutoPlayPreference() {
    try {
        const raw = window.localStorage.getItem(BGM_AUTO_PLAY_KEY);
        if (raw === "true") return true;
        if (raw === "false") return false;
        return null;
    } catch {
        return null;
    }
}

export function writeBgmAutoPlayPreference(enabled) {
    const on = Boolean(enabled);
    try {
        window.localStorage.setItem(BGM_AUTO_PLAY_KEY, on ? "true" : "false");
    } catch {
        /* quota or private mode */
    }
    if (!on) {
        AudioService.stopBgm();
    }
    try {
        window.dispatchEvent(new CustomEvent(BGM_AUTO_PLAY_EVENT, { detail: { enabled: on } }));
    } catch {
        /* ignore */
    }
}

/** Local mute wins until cloud settings are applied. */
export function resolveBgmAutoPlayPreference(fallback = false) {
    const stored = readBgmAutoPlayPreference();
    if (stored === false) return false;
    if (fallback === false) return false;
    if (stored === true) return true;
    return Boolean(fallback);
}
